var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M27.6348 51L27.6348 12L29.6348 12L29.6348 51L27.6348 51Z",
          fill: "#A0BEF8"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M46.6348 51.1317L46.6348 11.543L48.6348 11.543L48.6348 51.1317L46.6348 51.1317Z",
          fill: "#A0BEF8"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.63477 31L48.6348 31L48.6348 33L9.63477 33L9.63477 31Z",
          fill: "#A0BEF8"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.58117 12L49.1699 12L49.1699 14L9.58117 14L9.58117 12Z",
          fill: "#A0BEF8"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M11.6348 50V12H7.63477V54H48.6348V50H11.6348Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M57.0627 12.9766C57.0627 18.2051 52.8242 22.4435 47.5958 22.4435C42.3674 22.4435 38.1289 18.2051 38.1289 12.9766C38.1289 7.74823 42.3674 3.50977 47.5958 3.50977C52.8242 3.50977 57.0627 7.74823 57.0627 12.9766Z",
          fill: "#2C6FEF"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }